export default __webpack_public_path__ + "static/media/facebookWhite.ec1b23e7.svg";